<div class="col-md-12 px-5 py-0">
  <div class="d-flex col-md-12 justify-content-end p-0 mb-3"
    *ngIf="contract?.statusId != 5 && contract?.statusId != 6 && mode != 'view' && !dataLoading && editable">
    <button mat-raised-button color="accent" class="ml-3"
      *ngIf="(contract?.statusId == 1 || contract?.statusId == 9) && contract?.createdBy == userService.loggedinUser.id"
      (click)="openAddReviewer()" [disabled]="isLoading">Adhoc
      Reviewer</button>
    <button mat-raised-button color="accent" class="ml-3" (click)="sentForReview()"
      *ngIf="reviewers?.length > 0 && (contract?.statusId == 1 || contract?.statusId == 9) && contract?.createdBy == userService.loggedinUser.id"
      [disabled]="isLoading">Send for Review
      <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
    </button>
    <button mat-raised-button color="primary" class="ml-3 outlined-btn" (click)="recall()"
      *ngIf="reviewers?.length > 0 && contract?.statusId == 8 && contract?.createdBy == userService.loggedinUser.id"
      [disabled]="isLoading">Recall
      <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
    </button>
  </div>
  <div class="col-md-12 p-0">
    <ng-container *ngIf="!dataLoading; else reviewerSkeleton">
      <div class="no-data" *ngIf="showBypassReviewerNotice">
        <h4>No Reviewer was added to the flow</h4>
        <p>The Review workflow was bypassed for this contract.</p>
      </div>
      <div class="no-data" *ngIf="showReviewerEmptyState">
        <h4>No Reviewer was added to the flow</h4>
        <p>Please add reviewers for this contract!</p>
      </div>
      <ng-container *ngIf="!showBypassReviewerNotice && !showReviewerEmptyState">
        <div class="flex-wrap d-flex col-md-12 p-0">
          <div class="teamCard col-md-2 p-0" *ngFor="let reviewer of reviewers">
            <mat-card>
              <mat-card-header>
                <!-- Delete button - only show when status allows deletion -->
                <!-- <a mat-button color="accent" disableRipple class="position-absolute"
                  (click)="openDeleteConfirmation(reviewer.contractsReviewerId)"
                  *ngIf="contract?.createdBy == userService?.loggedinUser?.id && mode != 'view' && editable && contract?.statusId == 1"
                  [matTooltip]="'Delete Reviewer'" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon name="heroTrash"></ng-icon></a> -->
                  <button mat-icon-button 
                  (click)="openDeleteConfirmation(reviewer.contractsReviewerId)" 
                  [matTooltip]="'Delete Reviewer'" 
                  [matTooltipShowDelay]="300" 
                  [matTooltipHideDelay]="100"
                  class="position-absolute delete-icon-btn-header"
                  *ngIf="contract?.createdBy == userService?.loggedinUser?.id && mode != 'view' && editable && contract?.statusId == 1"
                  >
                  <img src="/assets/img/delete-svgrepo-com.svg" alt="Delete Reviewer" class="note-icon-img">
                </button>

                  <div class="profile">
                    <span>
                      <img [src]="reviewer.userInfo.profilePic ? 'data:image/png;base64,'+reviewer.userInfo.profilePic : '/assets/img/img_avatar.png'"
                        class="rounded-circle">
                    </span>
                  </div>
                <!-- View Notes icon - show in place of delete when status is review pending or approval pending -->
                <button mat-icon-button 
                  (click)="openViewNotes(reviewer)" 
                  [matTooltip]="'View Notes'" 
                  [matTooltipShowDelay]="300" 
                  [matTooltipHideDelay]="100"
                  class="position-absolute note-icon-btn-header"
                  >
                  <img src="/assets/img/note-notepad-svgrepo-com.svg" alt="View Notes" class="note-icon-img">
                </button>
               
              </mat-card-header>
              <mat-card-content>
                <mat-card-title>
                  {{reviewer.userInfo.firstName + ' ' + reviewer.userInfo.lastName |
                    titlecase}}
                </mat-card-title>
                <mat-card-subtitle>Internal Reviewer</mat-card-subtitle>
                <mat-card-subtitle>Step No. {{reviewer.sequenceNo}}</mat-card-subtitle>
                <mat-card-subtitle class="py-2 d-flex justify-content-center"
                  *ngIf="contract?.createdBy == userService.loggedinUser.id && mode != 'view' && editable">
                  <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
                    *ngIf="isToggleLoading[reviewer.contractsReviewerId]; else loaded"></mat-progress-spinner>
                  <ng-template #loaded>
                    <label class="switch">
                      <input class="switch-input" type="checkbox" [checked]="reviewer.isActive === true"
                        (change)="toggleReviewerStatus(reviewer.contractsReviewerId)"
                        [disabled]="[8,2,3].includes(contract?.statusId)">
                      <div class="switch-button">
                        <span class="switch-button-left">Inactive</span>
                        <span class="switch-button-right">Active</span>
                      </div>
                  </label>
                  </ng-template>
                </mat-card-subtitle>
              </mat-card-content>
              <mat-divider></mat-divider>
              <mat-card-actions class="d-flex justify-content-center" [class.error-background]="reviewer.status == 2"
                [class.success-background]="reviewer.status == 1" *ngIf="reviewers?.length > 0 && contract?.statusId != 1">
                <span>{{
                  reviewer.status == 1
                  ? "Reviewed"
                  : reviewer.status == 2
                  ? "Declined"
                  : "Review Pending"
                  }} </span>
                <a *ngIf="reviewer.status == 2" mat-button [matTooltip]="'View Decline Reasons'"
                  (click)="openRejectReason(reviewer)" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
                  disableRipple>
                  <ng-icon name="heroEye"></ng-icon>
                </a>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #reviewerSkeleton>
      <div class="flex-wrap d-flex col-md-12 p-0">
      <div class="col-md-2">
        <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
      </div>
      <div class="col-md-2">
        <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
      </div>
      <div class="col-md-2">
        <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
      </div>
      <div class="col-md-2">
        <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
      </div>
      <div class="col-md-2">
        <ngx-skeleton-loader [theme]="{ height: '200px', width: '100%'}"></ngx-skeleton-loader>
      </div>
      </div>
    </ng-template>
  </div>
</div>